import "./index.css";

import React, { Component } from "react";
import { Link } from "react-router-dom";

/* Components */
import Page from "../../../components/Page";
import NavigationBar from "../../../components/NavigationBar";
import WebFooter from "../../../components/WebFooter";

const perks = [
    {
        title: "High-calibre crew",
        body: "Through our considerable network of contacts, we handpick the best available crew to meet your needs.",
    },
    {
        title: "Industry experience",
        body: "Our recruiters are qualified marine professionals with yachting experience, understanding the ebbs and flows of life at sea.",
    },
    {
        title: "MLC registered",
        body: "An MLC registered crew agency based in the UK, with the standards and accountability that comes with it.",
    },
    {
        title: "Built-for-yachting technology",
        body: "Our proprietary platform helps us match the right candidates to the right vessels - faster.",
    },
];

const testimonials = [
    { quote: "We have used J4Crew for over 10 years now and have always been 100% satisfied with the services provided.", name: "Rich Swansbury", role: "Technical Superintendant" },
    { quote: "These guys are awesome. Really helpful. Got my first job through them and I'll use them every time I need one. One of the best for sure.", name: "Alex Smith", role: "EOOW Engineer" },
    { quote: "I began using J4Crew more than 10 years ago and he has been my primary contact whenever I am seeking new roles on large yachts. Truly, best-in-class service.", name: "Simon Glass", role: "USCG Chief Engineer Unlimited" },
    { quote: "J4Crew have placed me on several boats over the last 10 years. Great service and always quick to respond. No ridiculously long forms full of impersonal questions. Would recommend to anyone in yachting.", name: "Tom Pearson", role: "Class 2 Engineer" },
    { quote: "Since I joined yachting in 2008, J4Crew have always played a primordial role, providing an outstanding and personal service and placing me on the right yacht every time.", name: "Ignacio Bordenave", role: "Y1 Engineer" },
    { quote: "I would not hesitate to recommend J4Crew as the best engineering recruitment agency. Professional, dedicated, and a great option for beginners and seasoned engineers alike.", name: "Juan Riauba", role: "Y1 Engineer" },
];

class Home extends Component {

    constructor(props) {
        super(props);
        this.scrollDownRef = React.createRef();
    }

    componentDidMount() {
        document.title = "J4Crew - Professional Yacht Crew Agency";
        return window.scrollTo(0, 0);
    }

    render() {

        return(
            <Page match={this.props.match} hideNavbar={true}>
                <section className="home-hero">
                    <div className="home-hero-overlay">
                        <NavigationBar />
                        <div className="home-hero-content">
                            <p className="home-hero-eyebrow">Yacht crew agency · Est. 1999</p>
                            <h1 className="home-hero-title">
                                Quietly excellent<br />yacht crew recruitment.
                            </h1>
                            <p className="home-hero-subtitle">A small, specialist team finding the right crew for the right vessels - one match at a time.</p>
                            <div className="home-hero-actions">
                                <Link to={"/find-jobs"} className="home-btn home-btn-primary">Find jobs</Link>
                                <Link to={"/looking-for-crew"} className="home-btn home-btn-ghost">Looking for crew?</Link>
                            </div>
                        </div>
                        <button type="button" className="home-hero-scroll" onClick={() => this.scrollDownRef.current.scrollIntoView({ behavior: "smooth", block: "start" })} aria-label="Scroll to more">
                            <img src={require("../../../assets/svgs/scroll-down.svg")} alt="" />
                        </button>
                    </div>
                </section>

                <section className="home-section home-intro" ref={this.scrollDownRef}>
                    <p className="home-section-eyebrow">Our approach</p>
                    <h2 className="home-section-title">Bespoke, world-class recruitment.</h2>
                    <p className="home-section-lead">Since 1999, we have established ourselves as an industry leader and built long-term relationships with our clients and crew. We focus on quality over quantity. While we specialise in engineering, we cover every department on board - finding the best crew available for each position. Having done the job ourselves, we know how it works.</p>
                </section>

                <section className="home-section home-perks">
                    <div className="home-perks-grid">
                        {perks.map((perk) => (
                            <div key={perk.title} className="home-perk-card">
                                <h3 className="home-perk-title">{perk.title}</h3>
                                <p className="home-perk-body">{perk.body}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <img className="home-divider-image" src={require("../../../assets/images/palma-1.webp")} alt="Palma de Mallorca harbour" />

                <section className="home-section home-about">
                    <div className="home-about-grid">
                        <div className="home-about-text">
                            <p className="home-section-eyebrow">About us</p>
                            <h2 className="home-section-title">Run by people who've done the job.</h2>
                            <p className="home-section-lead">Jacob Hodgson is an expert in his field and understands what it takes to work on the most prestigious super yachts.</p>
                            <Link to={"/about-us"} className="home-btn home-btn-secondary">
                                <span>Find out more</span>
                                <img src={require("../../../assets/svgs/find-out-more.svg")} alt="" />
                            </Link>
                        </div>
                        <div className="home-about-person">
                            <img className="home-about-portrait" src={require("../../../assets/images/jacob.webp")} alt="Jacob Hodgson" />
                            <h4 className="home-about-name">Jacob Hodgson</h4>
                            <p className="home-about-role">Director and Recruitment Consultant</p>
                            <p className="home-about-bio">Jacob is a qualified Deck OOW with both commercial and yachting experience. He joined in 2018 and continues to diligently match clients and crew.</p>
                            <div className="home-about-socials">
                                <a href={"https://www.linkedin.com/in/jacob-hodgson-259b8b120/"} target={"_blank"} rel="noopener noreferrer" aria-label="Jacob Hodgson on LinkedIn">
                                    <img src={require("../../../assets/svgs/linkedin.svg")} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <img className="home-divider-image" src={require("../../../assets/images/palma-2.webp")} alt="Palma de Mallorca coastline" />

                <section className="home-section home-testimonials">
                    <div className="home-testimonials-header">
                        <p className="home-section-eyebrow">Testimonials</p>
                        <h2 className="home-section-title">Don't just take our word for it.</h2>
                    </div>
                    <div className="home-testimonials-grid">
                        {testimonials.map((t, i) => (
                            <figure key={i} className="home-testimonial-card">
                                <blockquote className="home-testimonial-quote">{t.quote}</blockquote>
                                <figcaption className="home-testimonial-meta">
                                    <span className="home-testimonial-name">{t.name}</span>
                                    <span className="home-testimonial-role">{t.role}</span>
                                </figcaption>
                            </figure>
                        ))}
                    </div>
                </section>

                <section className="home-section home-cta">
                    <div className="home-cta-card">
                        <div className="home-cta-copy">
                            <p className="home-section-eyebrow">Let's get started</p>
                            <h2 className="home-section-title">Ready to get in touch?</h2>
                            <p className="home-section-lead">Whether you're a crew member looking for your next yacht or a captain looking to recruit, our team is ready to help.</p>
                        </div>
                        <div className="home-cta-actions">
                            <Link to={"/sign-up"} className="home-btn home-btn-primary">Register</Link>
                            <Link to={"/looking-for-crew"} className="home-btn home-btn-ghost-dark">Looking for crew?</Link>
                        </div>
                    </div>
                </section>

                <WebFooter />
            </Page>
        );

    }

}

export default Home;
